import React from "react";

/**
 * @typedef {import("../../../jsdoc/GroupData.js").GroupData} GroupData
 */

/**
 * BusinessSizeBreakdownInfoItem Component
 * @param {Object} props
 * @param {string} props.group
 * @param {GroupData} props.groupsData
 * @returns {React.JSX.Element}
 */
export default function BusinessSizeBreakdownInfoItem({ group, groupsData }) {
  return (
    <tr role="row" data-type={group}>
      <th id={group}>{group}</th>
      <td className="text-center" role="gridcell" headers="ch">
        {groupsData.chsA}
      </td>
      <td className="text-center" role="gridcell" headers="contract">
        {groupsData.contractsA}
      </td>
      <td className="text-center" role="gridcell" headers="ch">
        {groupsData.chsB}
      </td>
      <td className="text-center" role="gridcell" headers="contract">
        {groupsData.contractsB}
      </td>
    </tr>
  );
}
